export const timeZoneList = [
  { label: 'Eastern Standard Time (EST)', value: 'EST', timeZone: 'America/New_York' },
  { label: 'Central Standard Time (CST)', value: 'CST', timeZone: 'America/Chicago' },
  { label: 'Mountain Standard Time (MST)', value: 'MST', timeZone: 'America/Denver' },
  { label: 'Pacific Standard Time (PST)', value: 'PST', timeZone: 'America/Los_Angeles' }
]

export function getTimeZone(value) {
  let info = timeZoneList.find(item => item.value === value)
  if (info) {
    return info.timeZone
  }
  return value
}